/* global Image */
import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { FormGroup, HelpBlock, ControlLabel } from 'react-bootstrap'

const removeIcon = <span className='glyphicon glyphicon-remove' />

const UploadInput = ({ label, attr, record, onChange, errors, validationSuccess }) => {
  const getDominantColor = imgEl => {
    const blockSize = 5
    const defaultRGB = { r: 0, g: 0, b: 0 }
    const rgb = { r: 0, g: 0, b: 0 }
    const canvas = document.createElement('canvas')
    const context = canvas.getContext && canvas.getContext('2d')
    let data
    let i = -4
    let count = 0

    if (!context) {
      return defaultRGB
    }

    const height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height
    const width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width

    context.drawImage(imgEl, 0, 0)

    try {
      data = context.getImageData(0, 0, width, height)
    } catch (e) {
      return defaultRGB
    }

    const length = data.data.length

    while ((i += blockSize * 4) < length) {
      ++count
      rgb.r += data.data[i]
      rgb.g += data.data[i + 1]
      rgb.b += data.data[i + 2]
    }

    rgb.r = ~~(rgb.r / count)
    rgb.g = ~~(rgb.g / count)
    rgb.b = ~~(rgb.b / count)

    return rgb
  }

  const partToHex = (c, hex = c.toString(16)) => (hex.length == 1 ? `0${hex}` : hex)
  const rgbToHex = ({ r, g, b }) => ('#' + partToHex(r) + partToHex(g) + partToHex(b))

  function onFilesSelected (evt) {
    const file = evt.target.files[0]

    onChange(attr, file)
    // jpeg image size
    if (file && file.type && file.type === 'image/jpeg') {
      const img = new Image()
      img.src = window.URL.createObjectURL(file)
      img.onload = () => {
        window.URL.revokeObjectURL(img.src)
        const dominantRGB = getDominantColor(img)
        img && onChange(attr + '_width', img.naturalWidth)
        img && onChange(attr + '_height', img.naturalHeight)
        img && onChange('dominant_color', rgbToHex(dominantRGB))
      }
    }
  }

  const dominantColor = record.get('dominant_color') || null
  const errorText = errors ? errors.get(attr) : undefined
  const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)

  function handleDelete (e) {
    e.preventDefault()
    onChange(attr, null)
  }

  return (
    <FormGroup controlId={'video_type'} validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      <input type='file' onChange={onFilesSelected} />
      {
        record.get(attr) ? (
          <button type='button' className='btn btn-secondary btn-xs pull-left' onClick={handleDelete}>
            {removeIcon}
          </button>
        ) : null
      }
      {
        record.get(attr) && dominantColor != null ? (
          <p><i className='glyphicon glyphicon-stop' style={{ color: dominantColor }} /> {dominantColor} </p>
        ) : null
      }
      {errorText ? <div style={{ clear: 'both' }}><HelpBlock>{errorText}</HelpBlock></div> : null}
    </FormGroup>
  )
}

UploadInput.propTypes = {
  record: PropTypes.object.isRequired,
  attr: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired, // map with errors
  onChange: PropTypes.func.isRequired // file for upload chosen handler
}

export default observer(UploadInput)
